import apiCore from '../../utils/api-core'

export function getAllCompanies(includeInactive = '') {
  let queryParam = includeInactive == '' ? '' : '?includeInactive=false';
  return apiCore.get('/api/v1/companies' + queryParam)
}

export function getCompanyABTs(id) {
  return apiCore.get(`/api/v1/company/${id}/bots/abt`)
}

export function getCompanyById(id) {
  return apiCore.get(`/api/v1/companies/${id}`)
}

export function deleteCompany(id) {
  return apiCore.delete(`/api/v1/companies/${id}`)
}

export function createCompany(data) {
  return apiCore.post('/api/v1/companies', data)
}

export function updateCompany(id, data) {
  return apiCore.put(`/api/v1/companies/${id}`, data)
}
